module.exports = __webpack_public_path__ + "img/logo.9028148e.svg";